export default __webpack_public_path__ + "static/gym-8e80ab6f8b3c155d1c854117b955a2ee.gif";